(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86363],{

/***/ 42123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/wallet",
      function () {
        return __webpack_require__(66998);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Accounts"
}); /*END_META*/ 


/***/ }),

/***/ 90986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Adding Custom Styles"
}); /*END_META*/ 


/***/ }),

/***/ 48317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "App customisation"
}); /*END_META*/ 


/***/ }),

/***/ 11260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Features available in tradly apps"
}); /*END_META*/ 


/***/ }),

/***/ 35773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Appstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 25192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Attributes"
}); /*END_META*/ 


/***/ }),

/***/ 38430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Auth Systems"
}); /*END_META*/ 


/***/ }),

/***/ 56400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Branch Metrics"
}); /*END_META*/ 


/***/ }),

/***/ 94485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 31910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Category"
}); /*END_META*/ 


/***/ }),

/***/ 87630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "In-built Chat"
}); /*END_META*/ 


/***/ }),

/***/ 63113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Launch Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 26716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Cloudflare"
}); /*END_META*/ 


/***/ }),

/***/ 49128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Collections"
}); /*END_META*/ 


/***/ }),

/***/ 83544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Core Concepts"
}); /*END_META*/ 


/***/ }),

/***/ 67221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Commission"
}); /*END_META*/ 


/***/ }),

/***/ 68939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Composer"
}); /*END_META*/ 


/***/ }),

/***/ 7000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Coupon"
}); /*END_META*/ 


/***/ }),

/***/ 37177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Crowdfunding"
}); /*END_META*/ 


/***/ }),

/***/ 37607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Currencies"
}); /*END_META*/ 


/***/ }),

/***/ 48576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deeplinks"
}); /*END_META*/ 


/***/ }),

/***/ 38819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Delivery Methods"
}); /*END_META*/ 


/***/ }),

/***/ 80390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 61798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Domain Setup"
}); /*END_META*/ 


/***/ }),

/***/ 56331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Creating Dynamic Pages"
}); /*END_META*/ 


/***/ }),

/***/ 77659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editing Page Styles in Tradly"
}); /*END_META*/ 


/***/ }),

/***/ 60285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editor Basic Overview"
}); /*END_META*/ 


/***/ }),

/***/ 75562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solving Education"
}); /*END_META*/ 


/***/ }),

/***/ 14095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Email Setup"
}); /*END_META*/ 


/***/ }),

/***/ 37816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Discovery / Mobility Solutions"
}); /*END_META*/ 


/***/ }),

/***/ 21918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Facebook App"
}); /*END_META*/ 


/***/ }),

/***/ 9793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Firebase"
}); /*END_META*/ 


/***/ }),

/***/ 30531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Food Ecosystem"
}); /*END_META*/ 


/***/ }),

/***/ 96569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Analytics"
}); /*END_META*/ 


/***/ }),

/***/ 76536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Maps"
}); /*END_META*/ 


/***/ }),

/***/ 93959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Growth Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Integrations FAQ"
}); /*END_META*/ 


/***/ }),

/***/ 89182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Inventory / Stocks"
}); /*END_META*/ 


/***/ }),

/***/ 77992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Karix and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 89406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Language"
}); /*END_META*/ 


/***/ }),

/***/ 11866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Listings"
}); /*END_META*/ 


/***/ }),

/***/ 26787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Geo Location"
}); /*END_META*/ 


/***/ }),

/***/ 94691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "MangoPay"
}); /*END_META*/ 


/***/ }),

/***/ 79297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Media"
}); /*END_META*/ 


/***/ }),

/***/ 30293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Setting Up Negotiations"
}); /*END_META*/ 


/***/ }),

/***/ 53165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Netlify"
}); /*END_META*/ 


/***/ }),

/***/ 33775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Notifications"
}); /*END_META*/ 


/***/ }),

/***/ 84096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Online Payment Platform"
}); /*END_META*/ 


/***/ }),

/***/ 24521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Order & Checkout Methods"
}); /*END_META*/ 


/***/ }),

/***/ 11906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solutions Ideas"
}); /*END_META*/ 


/***/ }),

/***/ 64811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": 'PayDunya"'
}); /*END_META*/ 


/***/ }),

/***/ 30688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Payment Methods"
}); /*END_META*/ 


/***/ }),

/***/ 41394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Playstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 19904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Different Products"
}); /*END_META*/ 


/***/ }),

/***/ 38345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Promotion"
}); /*END_META*/ 


/***/ }),

/***/ 61582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Q&A - Comments"
}); /*END_META*/ 


/***/ }),

/***/ 97405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Razorpay"
}); /*END_META*/ 


/***/ }),

/***/ 86580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Render"
}); /*END_META*/ 


/***/ }),

/***/ 79248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Analytics Features"
}); /*END_META*/ 


/***/ }),

/***/ 63676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Revenue Model"
}); /*END_META*/ 


/***/ }),

/***/ 84053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Review and Ratings"
}); /*END_META*/ 


/***/ }),

/***/ 93118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Booking Schedules"
}); /*END_META*/ 


/***/ }),

/***/ 5586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Customizing Screens",
    "shortTitle": "Screens"
}); /*END_META*/ 


/***/ }),

/***/ 78533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Search & Filters"
}); /*END_META*/ 


/***/ }),

/***/ 12137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "SEO"
}); /*END_META*/ 


/***/ }),

/***/ 28309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist for Mobile Apps"
}); /*END_META*/ 


/***/ }),

/***/ 23344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Social Feed"
}); /*END_META*/ 


/***/ }),

/***/ 92647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Connect"
}); /*END_META*/ 


/***/ }),

/***/ 16764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Onboarding"
}); /*END_META*/ 


/***/ }),

/***/ 53402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Payments"
}); /*END_META*/ 


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stuart Delivery"
}); /*END_META*/ 


/***/ }),

/***/ 75493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Submitting Template to the Tradly Marketplace"
}); /*END_META*/ 


/***/ }),

/***/ 69764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Subscription revenue model"
}); /*END_META*/ 


/***/ }),

/***/ 40409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 27763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Taxation"
}); /*END_META*/ 


/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Template Creation"
}); /*END_META*/ 


/***/ }),

/***/ 48315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Test Apps"
}); /*END_META*/ 


/***/ }),

/***/ 78001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Custom Event Tracking"
}); /*END_META*/ 


/***/ }),

/***/ 22339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Translations"
}); /*END_META*/ 


/***/ }),

/***/ 65268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Twilio and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 12464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Users"
}); /*END_META*/ 


/***/ }),

/***/ 65949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Variants"
}); /*END_META*/ 


/***/ }),

/***/ 75005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Vercel Deployment"
}); /*END_META*/ 


/***/ }),

/***/ 66998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _layouts_DocumentationLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53339);
/* harmony import */ var _layouts_ContentsLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33481);



/* @jsxRuntime classic */ /* @jsx mdx */ 



var Layout = _layouts_DocumentationLayout__WEBPACK_IMPORTED_MODULE_4__/* .DocumentationLayout */ .L;
var meta = {
    "id": "wallet",
    "title": "Account Wallet",
    "sidebar_label": "Account Wallet"
};
var slug = "wallet";
var tableOfContents = [
    {
        "title": "Account Wallet",
        "slug": "account-wallet",
        "children": []
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = _layouts_ContentsLayout__WEBPACK_IMPORTED_MODULE_5__/* .ContentsLayout */ .X_;
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "account-wallet",
        nextElement: {
            "type": "paragraph"
        }
    }, "Account Wallet"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Our platform includes an account wallet feature that allows accounts (sellers, service providers, campaign owners) to track and manage their sales and payouts. This feature is connected to Stripe Connect, which is used to process the payments for sales and payouts."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Using the account wallet feature, accounts can:"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "View their current balance, which is updated whenever they make a sale or receive a payout."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Request a payout to withdraw their balance to their linked bank account. Payouts are processed through Stripe Connect and may take a few days to complete."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "View a history of their sales and payouts, including the date, amount, and status of each transaction.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "The account wallet feature is a convenient and transparent way for accounts to track their earnings and manage their payouts. It helps to streamline the payment process and reduce the risk of errors or oversights."));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 99097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Account Wallet"
}); /*END_META*/ 


/***/ }),

/***/ 44717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Webhook"
}); /*END_META*/ 


/***/ }),

/***/ 67419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Things to setup in your website"
}); /*END_META*/ 


/***/ }),

/***/ 56012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Wishlist"
}); /*END_META*/ 


/***/ }),

/***/ 72957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Zapier"
}); /*END_META*/ 


/***/ }),

/***/ 53339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DocumentationLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21744);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52066);
/* harmony import */ var _components_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68224);
/* harmony import */ var _navs_documentation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54713);








function DocumentationLayout(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Title__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .D, {
                suffix: router.pathname === "/" ? undefined : "Tradly",
                children: props.layoutProps.meta.metaTitle || props.layoutProps.meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://tradly.app".concat(_img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)
                    }, "twitter:image"),
                    props.layoutProps.meta.canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: props.layoutProps.meta.canonical
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_1__/* .SidebarLayout */ .C, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                nav: _navs_documentation__WEBPACK_IMPORTED_MODULE_5__/* .documentationNav */ .u
            }, props))
        ]
    });
}
DocumentationLayout.nav = _navs_documentation__WEBPACK_IMPORTED_MODULE_5__/* .documentationNav */ .u;


/***/ }),

/***/ 54713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ documentationNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utils/importAll.js
function importAll(r) {
    return r.keys().map(function(fileName) {
        return {
            fileName: fileName,
            module: r(fileName)
        };
    });
}

;// CONCATENATED MODULE: ./src/utils/createPageList.js




function createPageList(files, base) {
    return importAll(files).reduce(function(acc, cur) {
        var slug = cur.fileName.substr(2).replace(/\.mdx$/, "");
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, slug, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur.module.default), {
            href: "/".concat(base, "/").concat(slug)
        })));
    }, {});
}

;// CONCATENATED MODULE: ./src/navs/documentation.js

var pages = createPageList(__webpack_require__(66708), "docs");
var documentationNav = {
    "Getting Started": [
        {
            title: "Setup",
            href: "/docs/setup",
            match: /^\/docs\/setup/
        },
        pages["commerce-definitions"],
        pages["checklist"],
        pages["appcustomisation"],
        pages["testingapp"],
        pages["products"],
        pages["translations"], 
    ],
    "Building Blocks": [
        pages["users"],
        pages["listings"],
        pages["attributes"],
        pages["variants"],
        pages["category"],
        pages["media"],
        pages["review-ratings"],
        pages["location"],
        pages["schedules"],
        pages["search"],
        pages["tags"],
        pages["wishlist"],
        pages["qa-comments"],
        pages["notifications"],
        pages["negotiations"],
        pages["inventory"], 
    ],
    Marketing: [
        pages["collection"],
        pages["promotion"],
        pages["coupon"],
        pages["seo"],
        pages["tracking"], 
    ],
    "Marketplace & Platform": [
        pages["accounts"],
        pages["wallet"],
        pages["chat"],
        pages["social"]
    ],
    "Business Blocks": [
        pages["delivery"],
        pages["paymentgateways"],
        pages["revenuemodel"],
        pages["commission"],
        pages["order"],
        pages["tax"], 
    ],
    "System Blocks": [
        pages["auth"],
        pages["language"],
        pages["currency"],
        pages["email"],
        pages["domain"], 
    ],
    "Editor Guides": [
        pages["template-create"],
        pages["editor-overview"],
        pages["editing-page-styles"],
        pages["dynamic-page"],
        pages["submit-template"], 
    ],
    Deployment: [
        pages["deployment"],
        pages["playstore"],
        pages["appstore"],
        pages["vercel"],
        pages["netlify"], 
    ],
    "Native Integrations": [
        pages["integrations-overview"],
        pages["webhook"],
        pages["zapier"],
        pages["firebase"],
        pages["stripe-payments"],
        pages["stripe-connect"],
        pages["stripe-onboarding"],
        pages["mangopay"],
        pages["onlinepaymentplatform"],
        pages["stuart"],
        pages["branch"],
        pages["google-maps"],
        pages["ga"],
        pages["facebookapp"], 
    ],
    "Solution - UNSDG Goals": [
        pages["crowdfunding"],
        pages["food"],
        pages["education"],
        pages["energy"],
        pages["othersolutions"], 
    ]
};


/***/ }),

/***/ 66708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./accounts.mdx": 69056,
	"./adding-custom-styles.mdx": 90986,
	"./appcustomisation.mdx": 48317,
	"./appfeatures.mdx": 11260,
	"./appstore.mdx": 35773,
	"./attributes.mdx": 25192,
	"./auth.mdx": 38430,
	"./branch.mdx": 56400,
	"./build-marketplace.mdx": 94485,
	"./category.mdx": 31910,
	"./chat.mdx": 87630,
	"./checklist.mdx": 63113,
	"./cloudflare.mdx": 26716,
	"./collection.mdx": 49128,
	"./commerce-definitions.mdx": 83544,
	"./commission.mdx": 67221,
	"./composer.mdx": 68939,
	"./coupon.mdx": 7000,
	"./crowdfunding.mdx": 37177,
	"./currency.mdx": 37607,
	"./deeplinks.mdx": 48576,
	"./delivery.mdx": 38819,
	"./deployment.mdx": 80390,
	"./domain.mdx": 61798,
	"./dynamic-page.mdx": 56331,
	"./editing-page-styles.mdx": 77659,
	"./editor-overview.mdx": 60285,
	"./education.mdx": 75562,
	"./email.mdx": 14095,
	"./energy.mdx": 37816,
	"./facebookapp.mdx": 21918,
	"./firebase.mdx": 9793,
	"./food.mdx": 30531,
	"./ga.mdx": 96569,
	"./google-maps.mdx": 76536,
	"./growth.mdx": 93959,
	"./integrations-overview.mdx": 62951,
	"./inventory.mdx": 89182,
	"./karix.mdx": 77992,
	"./language.mdx": 89406,
	"./listings.mdx": 11866,
	"./location.mdx": 26787,
	"./mangopay.mdx": 94691,
	"./media.mdx": 79297,
	"./negotiations.mdx": 30293,
	"./netlify.mdx": 53165,
	"./notifications.mdx": 33775,
	"./onlinepaymentplatform.mdx": 84096,
	"./order.mdx": 24521,
	"./othersolutions.mdx": 11906,
	"./paydunya.mdx": 64811,
	"./paymentgateways.mdx": 30688,
	"./playstore.mdx": 41394,
	"./products.mdx": 19904,
	"./promotion.mdx": 38345,
	"./qa-comments.mdx": 61582,
	"./razorpay.mdx": 97405,
	"./render.mdx": 86580,
	"./reports.mdx": 79248,
	"./revenuemodel.mdx": 63676,
	"./review-ratings.mdx": 84053,
	"./schedules.mdx": 93118,
	"./screens.mdx": 5586,
	"./search.mdx": 78533,
	"./seo.mdx": 12137,
	"./setup-app.mdx": 28309,
	"./social.mdx": 23344,
	"./stripe-connect.mdx": 92647,
	"./stripe-onboarding.mdx": 16764,
	"./stripe-payments.mdx": 53402,
	"./stuart.mdx": 6882,
	"./submit-template.mdx": 75493,
	"./subscription.mdx": 69764,
	"./tags.mdx": 40409,
	"./tax.mdx": 27763,
	"./template-create.mdx": 25013,
	"./testingapp.mdx": 48315,
	"./tracking.mdx": 78001,
	"./translations.mdx": 22339,
	"./twilio.mdx": 65268,
	"./users.mdx": 12464,
	"./variants.mdx": 65949,
	"./vercel.mdx": 75005,
	"./wallet.mdx": 99097,
	"./webhook.mdx": 44717,
	"./website.mdx": 67419,
	"./wishlist.mdx": 56012,
	"./zapier.mdx": 72957,
	"src/pages/docs/accounts.mdx": 69056,
	"src/pages/docs/adding-custom-styles.mdx": 90986,
	"src/pages/docs/appcustomisation.mdx": 48317,
	"src/pages/docs/appfeatures.mdx": 11260,
	"src/pages/docs/appstore.mdx": 35773,
	"src/pages/docs/attributes.mdx": 25192,
	"src/pages/docs/auth.mdx": 38430,
	"src/pages/docs/branch.mdx": 56400,
	"src/pages/docs/build-marketplace.mdx": 94485,
	"src/pages/docs/category.mdx": 31910,
	"src/pages/docs/chat.mdx": 87630,
	"src/pages/docs/checklist.mdx": 63113,
	"src/pages/docs/cloudflare.mdx": 26716,
	"src/pages/docs/collection.mdx": 49128,
	"src/pages/docs/commerce-definitions.mdx": 83544,
	"src/pages/docs/commission.mdx": 67221,
	"src/pages/docs/composer.mdx": 68939,
	"src/pages/docs/coupon.mdx": 7000,
	"src/pages/docs/crowdfunding.mdx": 37177,
	"src/pages/docs/currency.mdx": 37607,
	"src/pages/docs/deeplinks.mdx": 48576,
	"src/pages/docs/delivery.mdx": 38819,
	"src/pages/docs/deployment.mdx": 80390,
	"src/pages/docs/domain.mdx": 61798,
	"src/pages/docs/dynamic-page.mdx": 56331,
	"src/pages/docs/editing-page-styles.mdx": 77659,
	"src/pages/docs/editor-overview.mdx": 60285,
	"src/pages/docs/education.mdx": 75562,
	"src/pages/docs/email.mdx": 14095,
	"src/pages/docs/energy.mdx": 37816,
	"src/pages/docs/facebookapp.mdx": 21918,
	"src/pages/docs/firebase.mdx": 9793,
	"src/pages/docs/food.mdx": 30531,
	"src/pages/docs/ga.mdx": 96569,
	"src/pages/docs/google-maps.mdx": 76536,
	"src/pages/docs/growth.mdx": 93959,
	"src/pages/docs/integrations-overview.mdx": 62951,
	"src/pages/docs/inventory.mdx": 89182,
	"src/pages/docs/karix.mdx": 77992,
	"src/pages/docs/language.mdx": 89406,
	"src/pages/docs/listings.mdx": 11866,
	"src/pages/docs/location.mdx": 26787,
	"src/pages/docs/mangopay.mdx": 94691,
	"src/pages/docs/media.mdx": 79297,
	"src/pages/docs/negotiations.mdx": 30293,
	"src/pages/docs/netlify.mdx": 53165,
	"src/pages/docs/notifications.mdx": 33775,
	"src/pages/docs/onlinepaymentplatform.mdx": 84096,
	"src/pages/docs/order.mdx": 24521,
	"src/pages/docs/othersolutions.mdx": 11906,
	"src/pages/docs/paydunya.mdx": 64811,
	"src/pages/docs/paymentgateways.mdx": 30688,
	"src/pages/docs/playstore.mdx": 41394,
	"src/pages/docs/products.mdx": 19904,
	"src/pages/docs/promotion.mdx": 38345,
	"src/pages/docs/qa-comments.mdx": 61582,
	"src/pages/docs/razorpay.mdx": 97405,
	"src/pages/docs/render.mdx": 86580,
	"src/pages/docs/reports.mdx": 79248,
	"src/pages/docs/revenuemodel.mdx": 63676,
	"src/pages/docs/review-ratings.mdx": 84053,
	"src/pages/docs/schedules.mdx": 93118,
	"src/pages/docs/screens.mdx": 5586,
	"src/pages/docs/search.mdx": 78533,
	"src/pages/docs/seo.mdx": 12137,
	"src/pages/docs/setup-app.mdx": 28309,
	"src/pages/docs/social.mdx": 23344,
	"src/pages/docs/stripe-connect.mdx": 92647,
	"src/pages/docs/stripe-onboarding.mdx": 16764,
	"src/pages/docs/stripe-payments.mdx": 53402,
	"src/pages/docs/stuart.mdx": 6882,
	"src/pages/docs/submit-template.mdx": 75493,
	"src/pages/docs/subscription.mdx": 69764,
	"src/pages/docs/tags.mdx": 40409,
	"src/pages/docs/tax.mdx": 27763,
	"src/pages/docs/template-create.mdx": 25013,
	"src/pages/docs/testingapp.mdx": 48315,
	"src/pages/docs/tracking.mdx": 78001,
	"src/pages/docs/translations.mdx": 22339,
	"src/pages/docs/twilio.mdx": 65268,
	"src/pages/docs/users.mdx": 12464,
	"src/pages/docs/variants.mdx": 65949,
	"src/pages/docs/vercel.mdx": 75005,
	"src/pages/docs/wallet.mdx": 99097,
	"src/pages/docs/webhook.mdx": 44717,
	"src/pages/docs/website.mdx": 67419,
	"src/pages/docs/wishlist.mdx": 56012,
	"src/pages/docs/zapier.mdx": 72957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66708;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,48777,26852,5679,49774,92888,40179], function() { return __webpack_exec__(42123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);